import tw from 'twin.macro';
import styled from 'styled-components';

export const ChallengeCardContainer = styled.div`
  ${tw`w-full h-full rounded-xl p-4 flex items-center justify-around`};
`;

// Images section
export const ChallengeCardImage = tw.img`w-20 h-20 object-cover rounded-full`;
export const ChallengeCardImageCoin = tw.img`w-[0.875rem] h-4`;

// Text section
export const ChallengeCardCoin = tw.div`w-[4.125rem] h-[2rem] bg-red rounded-full
flex items-center justify-around p-1.5 text-white gap-1`;

// content section
export const ChallengeCardContent = tw.div`flex h-full pl-4 py-2 gap-4 items-start justify-around`;
export const ChallengeCardContentTitles = tw.div`h-full flex flex-col w-[8.75rem] gap-1`;
